"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runRemoteServer = exports.renderingIndexHtml = exports.renderingFileList = exports.getFiles = void 0;
var mfe_1 = require("../mfe");
function getFiles(dir, files, deps) {
    var fs = deps.fs;
    files = files || {};
    try {
        var filesInDir = fs.readdirSync(dir);
        for (var i in filesInDir) {
            var fileName = filesInDir[i];
            var fileDir = dir + "/" + fileName;
            if (fs.statSync(fileDir).isDirectory()) {
                files[fileName] = getFiles(fileDir, {}, deps);
            }
            else {
                files["files"] = (files["files"] &&
                    files["files"].concat(fileName)) || [fileName];
            }
        }
    }
    catch (error) {
        // nothing to do
    }
    return files;
}
exports.getFiles = getFiles;
function renderingFileList(files, basePath, mfeName, env) {
    var allFiles = (files && files[env] && files[env]["files"]) || [];
    return allFiles.length > 0
        ? allFiles
            .map(function (fileName) {
            var colorLink = "black";
            switch (fileName) {
                case "main.js":
                    colorLink = "#f59e00";
                    break;
                case "remoteEntry.js":
                    colorLink = env === "server" ? "blue" : "#00ac00";
                    break;
                default:
                    colorLink = "black";
                    break;
            }
            return "<a style=\"color: ".concat(colorLink, "\" href=\"/").concat(basePath, "/").concat(mfeName, "/").concat(env, "/").concat(fileName, "\">").concat(fileName, "</a>");
        })
            .join("<br/>")
        : "<h3 style=\"color:red;\">ERRORE: FILE NON GENERATI</h3>";
}
exports.renderingFileList = renderingFileList;
function renderingIndexHtml(basePath, mfeSettings, dir, deps) {
    var fs = deps.fs;
    var filesMap = __assign(__assign({}, Object.keys(mfeSettings).reduce(function (acc, __mfeName__) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[__mfeName__] = {
            client: {
                files: [],
            },
            server: {
                files: [],
            },
        }, _a));
    }, {})), getFiles(dir, {}, { fs: fs }));
    var filesHtml = Object.entries(filesMap)
        .map(function (_a) {
        var mfeName = _a[0], envFiles = _a[1];
        return "\n        <tr>\n          <td style=\"border: 1px solid black; padding:10px;\">".concat(mfeName, "</td>\n          <td style=\"border: 1px solid black; padding:10px;\">\n            <table>\n              <tr>\n                <td>client</td>\n                <td style=\"border: 1px solid black; padding:10px;\">").concat(renderingFileList(envFiles, basePath, mfeName, "client"), "</td>\n              </tr>      \n              <tr>\n                <td>server</td>\n                <td style=\"border: 1px solid black; padding:10px;\">").concat(renderingFileList(envFiles, basePath, mfeName, "server"), "</td>\n              </tr>      \n            </table> \n          </td>\n        </tr> \n      ");
    })
        .join("");
    return "\n    <div>\n      <h1>ALL AVAILABLE ".concat(basePath, "</h1>\n      <table>\n        <tr>\n          <th>MFE_NAME</th>\n          <th>FILES</th>\n        </tr>\n        ").concat(filesHtml, "\n      </table> \n    </div>\n  ");
}
exports.renderingIndexHtml = renderingIndexHtml;
function runRemoteServer(remotesType, options, deps, enableHeadersLog) {
    if (enableHeadersLog === void 0) { enableHeadersLog = false; }
    var originalPort = options.port, deploy_env_name = options.deploy_env_name, dirname = options.dirname;
    var express = deps.express, path = deps.path, cors = deps.cors, compression = deps.compression, fs = deps.fs;
    var _a = mfe_1.MFE_GENERAL_SETTINGS[remotesType], localProdPort = _a.localProdPort, basePath = _a.basePath, mfeSettings = _a.mfeSettings;
    var port = originalPort || (deploy_env_name === "local" && localProdPort) || "8080";
    var app = express();
    app.use(compression());
    app.use(cors({
        origin: [
            "http://localhost:3000",
            "https://dev.unipolsai.it",
            "https://dev.unipol.it",
            "https://sit.unipolsai.it",
            "https://sit.unipol.it",
            "https://qa.unipolsai.it",
            "https://qa.unipol.it",
            "https://fix.unipolsai.it",
            "https://fix.unipol.it",
            "https://unipolsai.it",
            "https://unipol.it",
            "https://www.unipolsai.it",
            "https://www.unipol.it",
            "https://authoring-inte.unipolsai.it",
            "https://authoring-inte.unipol.it",
            "https://authoring-svil.unipolsai.it",
            "https://authoring-svil.unipol.it",
            "https://authoring-coll.unipolsai.it",
            "https://authoring-coll.unipol.it",
            "https://authoring.unipolsai.it",
            "https://authoring.unipol.it",
            "https://svil.unipolsai.it",
            "https://svil.unipol.it",
            "https://inte.unipolsai.it",
            "https://inte.unipol.it",
            "https://coll.unipolsai.it",
            "https://coll.unipol.it",
            "https://evo-dev.unipolsai.it",
            "https://evo-dev.unipol.it",
            "https://evo-sit.unipolsai.it",
            "https://evo-sit.unipol.it", // rebranding midnight 2025
        ],
    }));
    app.use(function (req, _, next) {
        console.log("Resource Requested: ", req.url);
        enableHeadersLog && console.log("Request headers: ", JSON.stringify(req.headers));
        enableHeadersLog && console.log("Response headers: ", _.getHeaders());
        next();
    });
    app.use("/".concat(basePath), express.static(path.join(dirname, "../dist")));
    app.get("/".concat(basePath, "/index.html"), function (_, res) {
        var dir = path.join(dirname, "../dist");
        var html = renderingIndexHtml(basePath, mfeSettings, dir, { fs: fs });
        res.send(html);
    });
    if (deploy_env_name === "local") {
        var dir = path.join(dirname, "../config/cert");
        var key = fs.readFileSync(dir + '/key.pem');
        var cert = fs.readFileSync(dir + '/cert.pem');
        var https = require('https');
        var server = https.createServer({ key: key, cert: cert }, app);
        server.listen(port, function () {
            console.log("Node Express Server for ".concat(basePath, " is listening on PORT: ").concat(port));
        });
    }
    else {
        app.listen(port, function () {
            console.log("Node Express Server for ".concat(basePath, " is listening on PORT: ").concat(port));
        });
    }
}
exports.runRemoteServer = runRemoteServer;
